<div *ngIf="formFields.length > 0 ">
  <form (ngSubmit)="onSubmit()" [formGroup]="form" [disabled]="liquidando">
    <div *ngFor="let formField of formFields" class="form-group">
      <app-dynamic-form-input [input]="formField" [form]="form"></app-dynamic-form-input>
    </div>

    <div class="form-group">
      <hr>
      <button class="btn btn-primary col-lg-4" [disabled]="form.invalid || liquidando">Liquidar</button>
      <button class="btn btn-secondary col-lg-2" [disabled]="liquidando" (click)="verResultados()">Resultados</button>
      <div *ngIf="liquidacionInvalida">
        <br>
        <mat-error class="liquidacionInvalida">{{MensajeError}}</mat-error>
      </div>
    </div>   
  </form>
      
  <!--<div *ngIf="payLoad" class="form-group">
    <strong>Parametros para liquidar</strong><br>{{payLoad}}
  </div>-->
</div>
